import { Component, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FunctionsService } from 'src/app/modules/shared/services/functions.service';
import { TravelCashService } from '../../services/travel-cash/travel-cash.service';
import { travelCashUrl } from 'src/app/modules/shared/common/api';
import { Travel } from 'src/app/models/travel';
import { TravelCashAdvanceAddComponent } from '../travel-cash-advance-add/travel-cash-advance-add.component';
import { TravelCashAdvanceViewComponent } from '../travel-cash-advance-view/travel-cash-advance-view.component';
import { User } from 'src/app/models/user';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { TravelService } from 'src/app/modules/travel/services/travel/travel.service';
import { NotifyboxComponent } from 'src/app/modules/shared/components/notifybox/notifybox.component';
import { ConfirmationMessageComponent } from 'src/app/modules/shared/components/confirmation-message/confirmation-message.component';

@Component({
  selector: 'app-travel-cash-advance-list',
  templateUrl: './travel-cash-advance-list.component.html',
  styleUrls: ['./travel-cash-advance-list.component.scss']
})
export class TravelCashAdvanceListComponent implements OnInit {

  keyWords = [];
  menuList = [
    {
      label:"Date Submitted",
      type: 'date',
      name:"date_submitted",
      value: [],
    },
    {
      label:"Purpose",
      type:"input",
      name:"purpose",
    },
    {
      label:"Location",
      type:"input",
      name:"location",
    },
    {
      label:"Status",
      type:"select",
      name:"status",
      value: ["Draft","For 1st Approval","For 2nd Approval","Approved","Rejected","Cancelled","Push Back"]
    }
  ];
  
  pipe = new DatePipe('en-US');

  option =  {
    btnOk:'Yes',
    btnCancel: 'Cancel',
  }

  isNoResult: boolean = false;
  loading:boolean = false;
  isRole:boolean = false;
  isKeyWord:boolean = false;
  isMax:boolean = false;
  msgErr:any;
  keyTable = '';
  msg = "";
  res:any;

  params:any;

  totalRec : number;
  page: number = 1;
  perPage: number;

  travel: any;
  dialogConfig:any;
  departmentList:any;
  formGroup: FormGroup;
  user = new User();

  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public travelCashService: TravelCashService,
    public functionService: FunctionsService,
    public travelService: TravelService,
    private route: ActivatedRoute
  ) {
    this.isRole = this.user.getRole();
   }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      travel_authorization_no:['',null],
      cash_advance_no:['',null],
      complete_name: ['',null],
      date_filed: ['',null],
      date_submitted: ['',null],
      travel_reason:['',null],
      location: ['',null],
      purpose:['',null],
      status: ['',null],
      department_filter: ['',null]
    });

    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.width = '800px';
    this.dialogConfig.height = '100%';
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';
    this.dialogConfig.backdropClass = 'mat-dialog-backdrop';
    if (this.isRole) {
      this.menuList.unshift({
        label:"Requestor",
        type:"input",
        name:"complete_name"
      });
    }

    //check status param router if set
    var stat =  this.route.snapshot.paramMap.get("status");
    this.route.queryParams.subscribe( params =>{

      if (params['email']) {
        this.params = params;
        this.formGroup.controls['travel_authorization_no'].setValue(params['email']);
        this.getFilter();
        return;
      }

      if (params) {
        this.formGroup.controls['status'].setValue(params.status);
        this.formGroup.controls['complete_name'].setValue(params.name);
        this.getFilter();
      } else {
        this.getList();
      }
    });

  }

  getFilter() {
    this.page = 1;
    this.isKeyWord = true;
    if (this.isKeyWord) {
      this.keyTable = 'table-chiplist';
    }
    if(this.formGroup.controls['date_submitted'].value !== '' && this.formGroup.controls['date_submitted'].value !== null){
      this.formGroup.controls['date_submitted'].setValue(this.pipe.transform(this.formGroup.controls['date_submitted'].value, 'yyyy-MM-dd'));
    }
    this.getList();
    this.keyWords = this.functionService.filter(this.formGroup,this.keyWords);
  }

  getList() {
    let param = [];
    let queryString = '';

    if (this.page) {
      param.push('page='+this.page);
    }  

    if(this.formGroup.controls['cash_advance_no'].value !== null){
      param.push('cash_advance_no='+encodeURIComponent(this.formGroup.controls['cash_advance_no'].value));
    }

    if(this.formGroup.controls['travel_authorization_no'].value !== null){
      param.push('travel_authorization_no='+encodeURIComponent(this.formGroup.controls['travel_authorization_no'].value));
    }

    if(this.formGroup.controls['complete_name'].value !== null){
      param.push('complete_name='+this.formGroup.controls['complete_name'].value);
    }
    
    if(this.formGroup.controls['date_submitted'].value !== null){
      param.push('date_submitted='+this.formGroup.controls['date_submitted'].value);
    }

    if(this.formGroup.controls['status'].value !== null){
      param.push('status='+this.formGroup.controls['status'].value);
    }

    if(this.formGroup.controls['department_filter'].value !== null){
      param.push('department_filter='+this.formGroup.controls['department_filter'].value);
    }

    if(this.formGroup.controls['travel_reason'].value !== null){
      param.push('purpose='+this.formGroup.controls['travel_reason'].value);
    }

    if(this.formGroup.controls['location'].value !== null){
      param.push('location='+this.formGroup.controls['location'].value);
    }
  
    if (param.length) {
      queryString = '?' + param.join('&');
    }

    this.loading = true;
    this.isNoResult = false;
    this.travelCashService.url = travelCashUrl+''+ queryString;
    this.travelCashService.getFilter().subscribe(res=>{
      this.travel = new Travel(res.data);
      if (this.params) {
        this.openDetail(res.data[0]);
        this.params = '';
      }
      this.totalRec = res.total;
      this.perPage = res.per_page;
      this.loading = false;
      if (res.total == 0) {
        this.isNoResult = true;
      }
    });
  }

  onClearForm() {
    this.formGroup.reset();
    this.keyWords = [];
    this.getList();
    this.isKeyWord  = false;
    this.keyTable = '';
  }

  close() {
    this.msg = "";
    this.res = null;
  }

  delete() {
    this.loading = true;
    let data = {
      status: 'Delete as Draft',

    }
    this.dialog.open(NotifyboxComponent, {
      disableClose:true,
      data: {
        reload:false,
        label:'Ok',
        message: 'Success'
      }
    });
    
    this.travelCashService.updateStatus(this.res.id,data).subscribe(res=>{
      this.getList();
      this.msg = "";
      this.loading = false;
      this.res = null;
    },(err =>{
      this.loading = false;
      this.travel.setErrors(err.error.errors);
      this.travel.triggerErrors(err.error.errors);
    }));
  }

    /**
   * Delete Travel Authorization Data
   */
  deleteAsDraft(res) {
    this.res = res;
    let dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      disableClose:true,
      data: {
        message: "Are you sure you want to delete this draft?"
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.delete();
      }
    });
  }

  openDetail(res) {
    this.dialogConfig.data = {res};
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.width = '100vw';
    let dialogRef = this.dialog.open(TravelCashAdvanceViewComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getList();
      }
    });
  }

  createDialog(res) {
    this.loading = true;
    this.dialogConfig.width = '100vw';
    this.travelService.url = travelCashUrl+'/overdue';
    this.travelService.getFilter().subscribe(res=>{
      this.loading = false;
      let dialogRef = this.dialog.open(TravelCashAdvanceAddComponent, this.dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.getList();
        }
        this.isMax = false;
      });
      this.loading = false;
    },(err => {
      this.isMax = true;
      this.loading = false;
      this.dialog.open(NotifyboxComponent, {
        data: {
         reload: false,
         message: err.error.errors.overdue[0]
        }
       })
    }));
  }

  closeMsg() {
    this.isMax = false;
  }  

  pageChange(newPage: number) {
    this.page = newPage;
    this.getList();
		return false;
  }
  
  removeKeywords(key){
    this.formGroup.controls[key].setValue('');
    this.functionService.removeFilter(this.keyWords,key);
    this.getList();
    this.keyTable = '';
  }


}
